/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Jan 2022
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import classes from './SlotContent.module.css';
import FireboardUtils from '../../../../../util/fireboard-util';

const SlotContent = props => {
  const { showDeliveryVendor, showMarketplaceVendor, showCheckNumber, showPickupTime, check, WebkitLineClamp } = props;
  const { checkNumber, deliverTo, orders } = check || {};
  const [order0] = orders || [];
  const {
    delivery,
    deliveryVendorName,
    externalOrderNumber,
    marketplace,
    marketplaceVendorName,
    marketplaceOrderId,
    pickupDate,
  } = order0 || {};

  let vendorName = '', vendorId = '';
  if (delivery && !marketplace) {
    vendorName = deliveryVendorName || '';
    vendorId = externalOrderNumber || '';
  } else if (marketplace === true) {
    vendorName = marketplaceVendorName || '';
    vendorId = marketplaceOrderId || '';
  }

  const pickupTime = pickupDate ? FireboardUtils.getTimeInHrsMins(pickupDate) : '';

  return (
    <div className={classes.contentWrapper}>
      {showCheckNumber &&
        <div className={classes.label}>
          <span className={classes.value}>{checkNumber}</span>
        </div>
      }
      <div style={{ WebkitLineClamp: WebkitLineClamp || 1 }} className={classNames({ [classes.label]: true, [classes.wrappedContent]: true })}>
        <span className={classes.value}>{deliverTo}</span>
      </div>
      {showPickupTime && (
        <div className={classNames({ [classes.label]: true, [classes.wrappedContent]: true })}>
          <span className={classes.value}>{pickupTime}</span>
        </div>
      )}
      {showDeliveryVendor && (
        <div className={classNames({ [classes.label]: true, [classes.wrappedContent]: true })}>
          <span className={classes.value}>{vendorName}</span>
        </div>
      )}
      {showMarketplaceVendor && (
        <div className={classNames({ [classes.label]: true, [classes.wrappedContent]: true })}>
          <span className={classes.value}>{vendorId}</span>
        </div>
      )}
    </div>
  );
};

export default SlotContent;

SlotContent.propTypes = {
  showDeliveryVendor: PropTypes.bool,
  showMarketplaceVendor: PropTypes.bool,
  showCheckNumber: PropTypes.bool,
  showPickupTime: PropTypes.bool,
  check: PropTypes.object,
  WebkitLineClamp: PropTypes.number,
};

SlotContent.defaultProps = {
  showDeliveryVendor: true,
  showMarketplaceVendor: true,
  showCheckNumber: true,
  showPickupTime: false,
  check: {},
  WebkitLineClamp: 1,
};
